import styled from "@emotion/styled";

export const OrderListSkeletonWrapper = styled.div(({ theme }) => ({
	display: "flex",
	padding: "24px 24px 10rem 24px",
	gap: "16px",
	flexDirection: "column",
	alignItems: "flex-start",
	backgroundColor: theme.project.colors.backgroundColors.main,
	boxShadow: `0 3px 1px -2px ${theme.project.colors.allColors.hex.grayscale.gray400}`
}));
